// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-hotel-root-view__portal-footer{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:100%;padding:10px 10px 10px 18px;background:#fff;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.5);box-shadow:0 2px 4px rgba(0,0,0,.5)}@media (min-width:768px){.my-hotel-root-view__portal-footer{display:none!important}}.my-hotel-root-view__footer{background:#fff}", ""]);
// Exports
module.exports = exports;
